import React from 'react'
import CareersLast from '../../components/careers/CareersLast'
import Team from '../../components/careers/Team'
import './Careers.css'
import OurValues from '../../components/careers/OurValues'
import OpenPositions from '../../components/careers/OpenPositions'
import LifeAtImpact from '../../components/careers/LifeAtImpact'

function Careers() {
  return (
    <div>
      <Team buttonText="Join Team" onButtonClick={""} className="teamButton" />
      <OurValues />
      <LifeAtImpact />
      {/* <OpenPositions buttonText="Apply" onButtonClick={""} className="applyButton" /> */}
      <CareersLast />
    </div>
  )
}

export default Careers
